// "Buffer" is shimmed in by browserify, and having our own module
// called Buffer is a source of annoying inconsistencies, so we use "Buf"
//
var Message = require('message');
var MessageList = require('messagelist');
var PrefMixins = require('prefmixins');
var perf = require('../lib/perf.es6');
var util = require('../lib/util.es6');


var Buf = Backbone.Model.extend($.extend({}, PrefMixins, {
    idAttribute: 'bid',
    initialize: function (data, options) {
        this.messages = new MessageList(null, { buffer: this });
        
        this.selected = false;
        this.active = false;
        this.unseen = false;
        this.lastSelected = null;
        this.unseenHighlights = [];
        this.bottomSeen = null;
        this.focusSeen = null;
        this.initialized = false;
        this.unseed = null;
        this.previousUnseen = null;
        this.inputHistory = []; // TODO store and retrieve this on server
        this.typing = [];
        
        this.session = options.session;
        this.connection = options.connection;
        this.user = this.connection.getUser();
        
        this.messageQueue = [];
        
        this.connectionStateChange();
        this.listenTo(this.connection, 'change:status change:fail_info', this.connectionStateChange);
        this.listenTo(this.connection, 'preinit', this.connectionInit);
        this.listenTo(this.session.backend, 'connected', this.startStreamReLoad);
        this.messages.bind('add', this.onAddMessage, this);
        
        PrefMixins.initialize.apply(this, arguments);
    },
    onAddMessage: function (message) {
        if (this.connection.isBacklogLoaded()) {
            var type = message.get('type');
            if (this.initializedMessageHandlers[type]) {
                this.initializedMessageHandlers[type].call(this, message);
            }
        }
    },
    getUser: function () {
        return this.user;
    },
    getNick: function () {
        return this.connection.getNick();
    },
    getCid: function () {
        return this.connection ? this.connection.getCid() : this.get('cid');
    },
    bid: function () {
        return this.get('bid');
    },
    getSlackUrl: function () {
        return this.connection.getSlackBaseUrl();
    },
    idName: function () {
        return this.getName();
    },
    idNamespace: function () {
        return '';
    },

    threadId: function (replyId) {
        return this.bid() + '-' + replyId;
    },
    isThreadCollapsed: function (msgId) {
        return false;
    },
    urlParts: function () {
        return [this.idNamespace(), this.idName()];
    },
    urlId: function () {
        return this.connection.joinUrlParts(this.urlParts());
    },
    url: function () {
        return this.connection.buildUrl(this.urlParts());
    },
    getId: function () {
        return this.connection.buildId(this.idNamespace(), this.idName());
    },
    checkFocusOnMakeBufferName: function (focusOnMakeBuffer) {
        return focusOnMakeBuffer === this.getName().toLowerCase();
    },
    getDisplayName: function () {
        return this.getName();
    },
    getDisplayNameWithConnection: function () {
        return this.getDisambiguatedDisplayName() + ' (' + this.connection.getDisplayName() + ')';
    },
    getTarget: function () {
        return this.getName();
    },
    getName: function () {
        return this.get('name') || this.get('chan');
    },
    normalise: function () {
        return this.connection.normaliseBufferName(this.getName());
    },
    normaliseDisplay: function () {
        return this.connection.normaliseBufferName(this.getDisplayName());
    },
    connectionStateChange: function () {
        // Override in sub classes
    },
    connectionInit: function () {
        this.flushMessageQueue();
    },
    isThread: function () {
        return false;
    },
    isChild: function () {
        return this.isChannel() || this.isConversation() || this.isThread();
    },
    isChannel: function () {
        return false;
    },
    isConversation: function () {
        return false;
    },
    isServerLog: function () {
        return false;
    },
    equals: function (buffer) {
        return this.bid() == buffer.bid();
    },
    setUnseen: function (value, message) {
        this.previousUnseen = this.unseen;
        this.unseen = value;

        if (message && message.isHighlightable()) {
            this.unseenHighlights.push(message);
        }
        if (this.previousUnseen != value) {
            this.trigger('unseenChange', this);
        }
        if (message && message.isHighlightable()) {
            this.trigger('unseenHighlightChange', this);
        }
    },
    queueMessage: function (message) {
        this.messageQueue.push(message);
    },
    flushMessageQueue: function () {
        this.messages.reset(this.messageQueue);
        this.messageQueue = [];
    },
    isUnrendered: function (type) {
        return $.inArray(type, Buf.unrendered_messages) !== -1 ||
            this.isConversation() && $.inArray(type, Buf.unrendered_pm_messages) !== -1;
    },
    startStreamReLoad: function (header) {
        if (!header.resumed && this.messages.length) {
            this.trackDiscontinuity = true;
        }
    },
    addMessage: function (data) {
        if (data.eid > 0 && !this.isUnrendered(data.type)) {
            if (this.getMessage(data.eid)) {
                if (this.session.isReloading()) {
                    // Dupe initial message on reload, no discontinuity
                    this.trackDiscontinuity = false;
                }
            } else {
                var message = new Message(data, {
                    buffer: this
                });
                if (this.connection.isInitialized()) {
                    this.messages.add(message);
                } else {
                    this.queueMessage(message);
                }
                
                if (this.session.isReloading() && this.trackDiscontinuity) {
                    // We actually will get one extra message over the max_backlog_size so that
                    // we don't misreport discontinuities at the limit.
                    // So if we've overshot the limit we can be certain there's a discontinuity
                    // but only if we discard the extra message
                    if (data.type == 'backlog_cache_init' || this.get('backlog_size') > this.get('max_backlog_size')) {
                        this.discontinuity = message;
                        // Set earliest eid for backlog loading to this message
                        this.setEarliestEid(message.id);
                    }
                    this.trackDiscontinuity = false;
                }
                if (!this.isDiscontinuity(message)) {
                    if (this.isMessageUnseen(message) && !message.isIgnored()) {
                        if (this.session.isInitialized() && !this.hasUnseen() && message.isSelf()) {
                            // If we're in a read channel, new messages from ourselves shouldn't mark the channel as unread
                            // This is to guard against you sending a message to a channel, then switching to another and
                            // when the server responds the channel will be marked as unread because you're not looking
                            // at it. So only needs to happen if we've had the initial backlog.
                            // We do want the message to bump the last_seen_eid count though
                            this.setLastSeen(message);
                        } else {
                            if (message.isImportant() && !message.isInCollapsedThread()) {
                                this.setUnseen(true, message);
                            }
                        }
                    }
                    
                    // Set earliest eid if we haven't set it yet (i.e. first message on initial backlog)
                    if (!this.getEarliestEid()) {
                        this.setEarliestEid(data.eid);
                    }
                    
                    // Set min_eid if it doesn't exist (i.e. we haven't had messages before)
                    if (!this.getFirst()) {
                        this.setFirst(data.eid);
                    }
                    
                    if (message.isNotable()) {
                        this.trigger('notableMessage:' + message.get('type'), message);
                    }
                }
            }
        }
        if (this.messageHandlers[data.type]) {
            this.messageHandlers[data.type].call(this, data);
        }
        this.triggerInitializedMessageEvent(data);
    },
    triggerInitializedMessageEvent: function (message) {
        if (this.connection.isBacklogLoaded()) {
            this.trigger('message:' + message.type, message);
        }
    },
    getTypers: function () {
        var typers = [];
        _.each(this.typing, function (item) {
            var member = this.getMember(item[0]);
            if (member && !member.isIgnored()) {
                typers.push(member);
            }
        }, this);
        return typers;
    },
    sendTyping: function (value) {
        return this.connection.typing({
            to: this.getTarget(),
            value: value
        });
    },
    setTyping: function (nick) {
        if (!nick) {
            return;
        }
        var timeout = setTimeout(_.bind(function () {
            this.updateTyping(nick);
        }, this), 6500);
        this.updateTyping(nick, {silentStop: true, reset: timeout});
    },
    updateTyping: function (nick, options) {
        if (!nick) {
            return;
        }
        options = options || {};
        var val;
        if (options.reset) {
            val = [nick, options.reset];
        }
        var found = _.find(this.typing, function (item, i) {
            if (item[0] === nick) {
                clearTimeout(item[1]);
                if (val) {
                    this.typing.splice(i, 1, val);
                } else {
                    this.typing.splice(i, 1);
                }
                if (!val && !options.silentStop) {
                    this.trigger('userTyping', nick, false);
                }
                return true;
            }
            return false;
        }, this);
        if (val && !found) {
            this.typing.push(val);
            this.trigger('userTyping', nick, true);
        }
    },
    messageHandlers: {
        buffer_archived: function (message) {
            this.setArchived();
            this.setLastSeen(message.last_seen_eid);
        },
        buffer_unarchived: function (message) {
            this.setUnarchived();
        },
        user_typing: function (message) {
            this.setTyping(message.from);
        },
        buffer_msg: function (message) {
            this.updateTyping(message.from);
        },
        buffer_me_msg: function (message) {
            this.updateTyping(message.from);
        },
    },
    initializedMessageHandlers: {},
    getMessage: function (eid) {
        return this.messages.get(eid);
    },
    eid: function (eid) {
        return (eid instanceof Message) ? eid.id : eid;
    },
    // Only makes sense in the context of an add event on this.messages
    hadUnseen: function () {
        return this.previousUnseen;
    },
    hasUnseen: function () {
        return this.unseen;
    },
    
    // Only makes sense in the context of an add event on this.messages
    getPreviousLastMessage: function () {
        return this.getLastMessage().previousMessage();
    },
    getLastMessage: function () {
        return this.messages.last();
    },
    getLastEditableMessage: function () {
        if (this.connection.hasReliableClientTags()) {
            var idx = this.messages.findLastIndex(function (m) {
                return m.doIsEditable() && m.hasSameAccount(this.user);
            }, this);
            if (idx !== -1) {
                return this.messages.at(idx);
            }
        }
    },
    
    getLastSeen: function () {
        var lastSeen = this.get('last_seen_eid');
        return lastSeen > 0 ? lastSeen : 0;
    },
    hasImportantMessagesAfter: function (start) {
        return !!this.countImportantMessagesBetween(start);
    },
    countMessagesBetween: function (start, end) {
        var endIndex = end ? end.index() : this.messages.length - 1;
        return endIndex - start.index();
    },
    countImportantMessagesBetween: function (start, end) { // exclusive at start, inclusive at end
        return _.filter(this.messages.toArray().slice(start.index() + 1, end && end.index()), function (m) {
            return !m.isIgnored() && m.isImportant() && !m.isInCollapsedThread();
        }, this).length;
    },
    trimmableMessages: function (firstRender, end) {
        var endIndex;
        if (end) {
            endIndex = end.index();
        }
        return _.filter(this.messages.slice(firstRender.index(), endIndex), function (m) {
            return m.isImportant() || m.isSelf();
        });
    },
    resetLastSeen: function () {
        var message = this.getLastSeenMessage();
        this._doSetLastSeen(message);
    },
    _doSetLastSeen: function (message) {
        if (message) {
            this.clearUnseenHighlightsUntil(message);
            this.updateBottomSeen(message);
            this.setUnseen(this.hasImportantMessagesAfter(message));
        }
    },
    setLastSeen: function (message) {
        if (!message) {
            return;
        }
        if (!(message instanceof Message)) {
            var eid = message;
            message = this.getMessage(message);
            // Can happen on heartbeat_echo, only update the value in that case
            if (!message) {
                this.set({'last_seen_eid': eid});
                return;
            }
        }
        this._doSetLastSeen(message);
        this.set({'last_seen_eid': message.id});
    },
    isMessageUnseen: function (eid) {
        eid = this.eid(eid);
        return eid > 0 && (!this.getLastSeen() || eid > this.getLastSeen());
    },
    isMessageLastSeen: function (eid) {
        eid = this.eid(eid);
        return eid > 0 && eid == this.getLastSeen();
    },
    getCreated: function () {
        return this.get('created');
    },
    getFirst: function () {
        // min_eid can be wrong if we have an artificial backlog_cache_init
        // message fetched from the backend
        var minEid = this.get('min_eid');
        var firstMessage = this.getFirstMessage();
        if (firstMessage && (!minEid || firstMessage.id < minEid)) {
            return firstMessage.id;
        } else {
            return minEid || 0;
        }
    },
    setFirst: function (eid) {
        this.set({min_eid: eid});
    },
    isDiscontinuity: function (eid) {
        if (this.discontinuity) {
            return this.discontinuity.id == this.eid(eid);
        }
        return false;
    },
    // Could be a non rendered message
    getEarliestEid: function () {
        if (this.isDiscontinuity(this.earliestEid)) {
            return this.eid(this.discontinuity.nextMessage());
        }
        return this.earliestEid;
    },
    setEarliestEid: function (eid) {
        this.earliestEid = eid;
    },
    // Only rendered messages
    getFirstMessage: function () {
        return this.messages.first();
    },
    isFullyLoaded: function () {
        var firstId = this.getFirst();
        if (firstId === 0) {
            // No events
            return true;
        }
        var firstMessage = this.getFirstMessage();
        return firstMessage.id == firstId || firstMessage.getMsgId() == firstId;
    },
    getLastSeenDate: function () {
        return new Date(this.session.backend.tsOffset(this.getLastSeen() / 1000));
    },
    // Can be undefined, in which case chatter bar won't include line count
    getLastSeenMessage: function () {
        var lastSeen = this.getLastSeen();
        // 1. Lookup the message
        var message = this.getMessage(lastSeen);
        if (!message) {
            var firstMessage = this.getFirstMessage();
            if (firstMessage && lastSeen >= firstMessage.id) {
                // 2. Message was transient and no longer in the backlog
                // Loop back till we find a previous message
                var index = _.sortedIndex(this.messages.pluck('eid'), lastSeen);
                while (!message && index > 0) {
                    message = this.messages.at(--index);
                }
            }
            // 3. If message appeared before the current backlog,
        }
        return message;
    },

    
    lockFocusSeen: function () {
        if (!this.focusSeen) {
            var lastMessage = this.getLastMessage();
            this.focusSeen = lastMessage;
            return true;
        }
    },
    lockBottomSeen: function () {
        if (!this.bottomSeen) {
            var lastMessage = this.getLastMessage();
            this.bottomSeen = lastMessage;
            return true;
        }
    },
    unlockFocusSeen: function () {
        this.focusSeen = null;
    },
    unlockBottomSeen: function () {
        this.bottomSeen = null;
    },
    isBelowBottomSeen: function (message) {
        if (this.bottomSeen) {
            return this.bottomSeen.id < message.id;
        }
    },
    updateBottomSeen: function (message) {
        if (this.session.isFocused() && this.isBelowBottomSeen(message)) {
            var previous = this.bottomSeen;
            if (previous) {
                this.bottomSeen = message;
            }
            if (this.isMessageLastSeen(previous)) {
                this.setLastSeen(this.bottomSeen);
            } else {
                this.clearUnseenHighlightsAfter(previous);
            }
            return true;
        }
    },
    getFocusSeen: function () {
        return this.focusSeen;
    },
    getBottomSeen: function () {
        return this.bottomSeen;
    },
    getLowestSeen: function () {
        return this.getBottomSeen() || this.getFocusSeen() || this.getLastMessage();
    },
    read: function () {
        this.setLastSeen(this.getFocusSeen() || this.getBottomSeen() || this.getLastMessage());
    },
    
    unseenHighlightCount: function () {
        return this.unseenHighlights.length;
    },
    unseenHighlightCountAfter: function (message) {
        return _.filter(this.unseenHighlights, function (highlight) {
            return highlight.id > message.id; // exclusive
        }).length;
    },
    unseenHighlightCountBefore: function (message) {
        return _.filter(this.unseenHighlights, function (highlight) {
            return highlight.id < message.id; // exclusive
        }).length;
    },
    hasUnseenHighlights: function () {
        return this.unseenHighlightCount() > 0;
    },
    spliceUnseenHighlights: function (start, count) {
        if (start !== null) {
            this.unseenHighlights.splice(start, count);
            this.trigger('unseenHighlightChange', this);
        }
    },
    clearUnseenHighlightsUntil: function (until) {
        var splice = null, spliceCount = 0;
        for (var i = 0; i < this.unseenHighlightCount(); i++) {
            if (this.unseenHighlights[i].id <= until.id) { // inclusive
                // Remove these
                if (splice === null) {
                    splice = i;
                }
                spliceCount++;
            } else {
                break;
            }
        }
        this.spliceUnseenHighlights(splice, spliceCount);
    },
    clearUnseenHighlightsAfter: function (start) {
        var splice = null, spliceCount = 0, hlID;
        var count = 0;
        for (var i = 0; i < this.unseenHighlightCount(); i++) {
            hlID = this.unseenHighlights[i].id;
            if (start.id >= hlID) {
                // Count upper remainder, before start point
                count++;
            } else {
                // Only clear until bottom seen, inclusive
                if (hlID <= this.getLowestSeen().id) {
                    // Remove these
                    if (splice === null) {
                        splice = i;
                    }
                    spliceCount++;
                }
            }
        }
        this.spliceUnseenHighlights(splice, spliceCount);
        return count;
    },
    getUnseenHighlights: function () {
        return this.unseenHighlights;
    },
    getTitle: function () {
        return this.getName();
    },
    getFullLabel: function () {
        return this.connection.getFullLabel() + ': ' + this.getTitle();
    },
    isDeferred: function () {
        return !!this.get('deferred');
    },
    isCacheReset: function () {
        var first = this.getFirstMessage();
        if (first && first.get('type') === 'backlog_cache_init' && first.id > this.getCreated()) {
            return true;
        }
        return false;
    },
    isTimeout: function () {
        return !!this.get('timeout');
    },
    getMembers: function () {
        return this.members;
    },
    getMember: function (nick) {
        var nickL = nick.toLowerCase();
        return this.members.find(function (m) {
            return nickL == m.getNick().toLowerCase();
        });
    },
    getMemberByUsermask: function (usermask) {
        return this.members.find(function (member) {
            return member.get('usermask') == usermask;
        });
    },
    setSelected: function (selected) {
        if (selected != this.selected) {
            this.selected = selected;
            return true;
        }
        return false;
    },
    select: function (options) {
        options = options || {};
        if (!options.automatic) {
            this.session.clearFocusOnMakes();
        }
        if (this.setSelected(true)) {
            perf.mark('bufferSelect');

            this.lastSelected = util.ts();

            this.session.bufferSelectedChange(this, {
                replace: options.replace
            });

            this.trigger('selectedChange', this);
            this.trigger('doneSelected', this);
        }

        return this;
    },
    deselect: function () {
        if (this.setSelected(false)) {
            this.trigger('selectedChange', this);
            
            if (this.shouldMarkAsReadOnSelect()) {
                this.read();
            }
        }

        return this;
    },
    isSelected: function () {
        return this.selected;
    },
    setActive: function (active) {
        if (active != this.active) {
            this.active = active;
            this.trigger('activeChange', this);
        }
    },
    activate: function () {
        this.setActive(true);
    },
    deactivate: function () {
        this.setActive(false);
    },
    isActive: function () {
        return this.active;
    },
    setInputHistory: function (inputHistory) {
        this.inputHistory = inputHistory;
    },
    pushInputHistory: function (message, reply) {
        this.inputHistory.push({msg: message, reply: reply});
    },
    // Actions
    connectionPost: function (method, message, callback) {
        return this.connection.post(method, message, callback);
    },
    post: function (method, message, callback) {
        return this.connectionPost(method, $.extend({
            id: this.bid()
        }, message), callback);
    },
    connectionSay: function (message, callback, options) {
        this._connectionSay('say', message, callback, options);
    },
    _connectionSay: function (method, message, callback, options) {
        options = options || {};
        var data = {
            to: this.getTarget(),
            msg: message
        };
        if (options.reqid) {
            data._reqid = options.reqid;
        }
        return this.connection[method](data, callback);
    },
    sayPaste: function (message, options) {
        options = options || {};
        options.silent = true;
        this._say('sayPaste', message, options);
    },
    _doSay: function (message, options) {
        this._say('say', message, options);
        if (options && options.onConfirm) {
            options.onConfirm();
        }
    },
    say: function (message, options) {
        options = options || {};
        if (message && message.length > Message.LONG_MESSAGE_LIMIT) {
            this.trigger('longMessageConfirm', _.bind(function () {
                this._doSay(message, options);
            }, this), options.onCancel);
        } else {
            this._doSay(message, options);
        }
    },
    _say: function (method, message, options) {
        options = options || {};
        var reqid = this._connectionSay(method, message, _.bind(function (response) {
            if (!response.success) {
                this.trigger('sayError', response, message);
            }
            if (options.callback) {
                options.callback(response);
            }
        }, this), options);
        if (!options.silent) {
            this.pushInputHistory(message);
            this.trigger('sayRequest', message, reqid);
        }
        return reqid;
    },
    _doReply: function (msgid, message, options) {
        var data = {
            to: this.getTarget(),
            msgid: msgid,
            reply: message
        };
        if (options.reqid) {
            data._reqid = options.reqid;
        }
        var reqid = this.connection.reply(data, options.callback);
        this.trigger('sayRequest', message, reqid);
        if (options && options.onConfirm) {
            options.onConfirm();
        }
    },
    reply: function (msgid, message, options) {
        options = options || {};
        if (message && message.length > Message.LONG_MESSAGE_LIMIT) {
            this.trigger('longMessageConfirm', _.bind(function () {
                this._doReply(msgid, message, options);
            }, this), options.onCancel);
        } else {
            this._doReply(msgid, message, options);
        }
    },
    deleteMessage: function (msgid, options) {
        options = options || {};
        var data = {
            to: this.getTarget(),
            msgid: msgid
        };
        if (options.reqid) {
            data._reqid = options.reqid;
        }
        var reqid = this.connection.deleteMessage(data, options.callback);
        if (options && options.onConfirm) {
            options.onConfirm();
        }
    },
    redactMessage: function (msgid, reason, options) {
        options = options || {};
        var data = {
            to: this.getTarget(),
            msgid: msgid,
            reason: reason
        };
        if (options.reqid) {
            data._reqid = options.reqid;
        }
        var reqid = this.connection.redactMessage(data, options.callback);
        if (options && options.onConfirm) {
            options.onConfirm();
        }
    },
    _doEditMessage: function (msgid, message, options) {
        var data = {
            to: this.getTarget(),
            msgid: msgid,
            edit: message
        };
        if (options.reqid) {
            data._reqid = options.reqid;
        }
        var reqid = this.connection.editMessage(data, options.callback);
        if (options && options.onConfirm) {
            options.onConfirm();
        }
    },
    editMessage: function (msgid, message, options) {
        options = options || {};
        if (message && message.length > Message.LONG_MESSAGE_LIMIT) {
            this.trigger('longMessageConfirm', _.bind(function () {
                this._doEditMessage(msgid, message, options);
            }, this), options.onCancel);
        } else {
            this._doEditMessage(msgid, message, options);
        }
    },
    react: function (msgid, reaction) {
        if (this.connection.isSlack()) {
            reaction = emoji.strip_colons_only(emoji.unified_to_text(reaction));
        }
        return this.connection.react({
            to: this.getTarget(),
            msgid: msgid,
            reaction: reaction
        });
    },
    loadBacklog: function (discontinuity) {
        // Fetch backlog
        var data = {
            bid: this.bid(),
            cid: this.getCid(),
            num: 150
        };
        var earliest = this.getEarliestEid();
        if (earliest) {
            data.beforeid = earliest;
        }
        this.session.backend.get('backlog', data, _.bind(function (response) {
            if (response.error === true || response.success === false) {
                this.trigger('fetchFailed', discontinuity);
            } else if (response.length && !response[0].eid) {
                // Simple check for a list of message json objs
                this.trigger('fetchFailed', discontinuity);
            } else {
                // We may have had a new earliest while waiting for the load
                earliest = this.getEarliestEid();
                // Update earliest eid
                if (response.length) {
                    this.setEarliestEid(response[0].eid);
                    // Clear discontinuities
                    this.discontinuity = null;
                }
                
                var messages = _.map(_.filter(response, function (message) {
                    return !this.getMessage(message.eid) && !this.isUnrendered(message.type);
                }, this), function (message) {
                    return new Message(message, {
                        buffer: this
                    });
                }, this);
                
                this.messages.add(messages, {
                    silent: true
                });
                var added = [];
                if (this.isDeferred()) {
                    this.undefer();
                }
                if (earliest) {
                    added = this.messages.filterBeforeEid(earliest);
                } else {
                    added = this.messages.toArray();
                }
                this.trigger('fetchLoaded', messages);
                this.trigger('fetched', added, earliest, discontinuity);
            }
        }, this));
    },
    undefer: function () {
        this.set({
            timeout: false,
            deferred: false
        });
    },
    unarchive: function () {
        this.post('unarchive-buffer');
        this.setUnarchived();
    },
    archive: function () {
        this.post('archive-buffer');
        this.setArchived();
    },
    setArchived: function () {
        this.set({archived: true});
    },
    setUnarchived: function () {
        this.set({archived: false});
    },
    isArchived: function () {
        return !!this.get('archived');
    },
    wasArchived: function () {
        return !!this.previous('archived');
    },
    setPinned: function (enable) {
        this.session.setPinnedBuffer(this, enable);
    },
    canPin: function () {
        return !this.isArchived();
    },
    isPinned: function () {
        return this.session.isPinnedBuffer(this);
    },
    isAmbiguouslyPinned: function () {
        return this.session.isPinnedBufferAmbiguous(this);
    },
    getDisambiguatedListName: function () {
        return this.disambiguateListName(this.getDisplayName(), this.getName());
    },
    getDisambiguatedDisplayName: function () {
        return this.disambiguateDisplayName(this.getDisplayName(), this.getName());
    },
    disambiguateDisplayName: function (displayName, plainName) {
        if (!this.connection.isSlack() && plainName && displayName.toLowerCase() != plainName.toLowerCase()) {
            displayName += ' (' + plainName + ')';
        }
        return displayName;
    },
    disambiguateListName: function (displayName, plainName) {
        displayName = this.disambiguateDisplayName(displayName, plainName);
        if (this.isAmbiguouslyPinned()) {
            displayName += ' (' + this.connection.getDisplayName() + ')';
        }
        return displayName;
    },
    
    // Prefs
    getPrefKey: function (key) {
        return 'buffer-' + key;
    },
    prefKeys: {
        // Key should be the non-default version
        // Val[0] is the opposite setting (needed for buffer level overrides of global settings)
        // Val[1] is the default return value for a non-negative getter,
        // e.g. inlineFilesAllowed checks files-disableinline and returns true
        // if it's not set
        'disableTrackUnread': ['enableTrackUnread', true],
        'enableReadOnSelect': ['disableReadOnSelect', false],
        'notifications-mute': ['notifications-mute-disable', false],
        'files-disableinline': ['files-enableinline', true],
        'attachments-disableinline': ['attachments-enableinline', true],
        'pastebin-disableinline': ['pastebin-enableinline', true],
        'twitter-disableinline': ['twitter-enableinline', true],
        'mastodon-enableinline': ['mastodon-disableinline', false],
        'bsky-enableinline': ['bsky-disableinline', false],
        'reddit-enableinline': ['reddit-disableinline', false],
        'inlineimages': ['inlineimages-disable', false],
        'chat-oneline': ['chat-multiline', true],
        'chat-norealname': ['chat-realname', true],
        'chat-nocolor': ['chat-color', true],
        'chat-nocodespan': ['chat-codespan', true],
        'chat-nocodeblock': ['chat-codeblock', true],
        'chat-noquote': ['chat-quote', true],
        'chat-deleted-show': ['chat-deleted-hide', false],
        'time-left': ['time-right', true],
        'avatars-off': ['avatars-on', true],
        'avatars-image-off': ['avatars-image-on', true]
    },
    setTrackingUnreadPref: function (enable) {
        this.setOverridePref(enable, 'disableTrackUnread');
    },
    setMarkAsReadOnSelectPref: function (enable) {
        this.setOverridePref(enable, 'enableReadOnSelect');
    },
    setMuteNotificationsPref: function (enable) {
        this.setOverridePref(enable, 'notifications-mute');
    },
    setInlineFilesPref: function (enable) {
        this.setOverridePref(enable, 'files-disableinline');
    },
    setInlineAttachmentsPref: function (enable) {
        this.setOverridePref(enable, 'attachments-disableinline');
    },
    setInlinePastesPref: function (enable) {
        this.setOverridePref(enable, 'pastebin-disableinline');
    },
    setInlineSocialMediaPref: function (enable) {
        this.setOverridePref(enable, 'twitter-disableinline');
    },
    setInlineMastodonPref: function (enable) {
        this.setOverridePref(enable, 'mastodon-enableinline');
    },
    setInlineBskyPref: function (enable) {
        this.setOverridePref(enable, 'bsky-enableinline');
    },
    setInlineRedditPref: function (enable) {
        this.setOverridePref(enable, 'reddit-enableinline');
    },
    setInlineImagesPref: function (enable) {
        this.setOverridePref(enable, 'inlineimages');
    },
    setMultilinePref: function (enable) {
        this.setOverridePref(enable, 'chat-oneline');
    },
    setRealnamePref: function (enable) {
        this.setOverridePref(enable, 'chat-norealname');
    },
    setTimeRightPref: function (enable) {
        this.setOverridePref(enable, 'time-left');
    },
    setFormatColorPref: function (enable) {
        this.setOverridePref(enable, 'chat-nocolor');
    },
    enableInlineImages: function () {
        this.setInlineImagesPref(true);
    },
    disableInlineImages: function () {
        this.setInlineImagesPref(false);
    },
    isTrackingUnread: function () {
        return this.checkPref('disableTrackUnread');
    },
    shouldMarkAsReadOnSelect: function () {
        return this.checkPref('enableReadOnSelect');
    },
    shouldMuteNotifications: function () {
        return this.checkPref('notifications-mute');
    },
    inlineFilesAllowed: function () {
        return this.checkPref('files-disableinline');
    },
    inlineAttachmentsAllowed: function () {
        return this.checkPref('attachments-disableinline');
    },
    inlinePastesAllowed: function () {
        return this.checkPref('pastebin-disableinline');
    },
    inlineSocialMediaAllowed: function () {
        return this.checkPref('twitter-disableinline');
    },
    inlineMastodonAllowed: function () {
        return this.checkPref('mastodon-enableinline');
    },
    inlineBskyAllowed: function () {
        return this.checkPref('bsky-enableinline');
    },
    inlineRedditAllowed: function () {
        return this.checkPref('reddit-enableinline');
    },
    inlineImagesAllowed: function () {
        return this.checkPref('inlineimages');
    },
    embedExternalAvatars: function () {
        return this.imageAvatarsEnabled() && this.inlineImagesAllowed();
    },
    multiline: function () {
        return this.checkPref('chat-oneline');
    },
    formatColor: function () {
        return this.checkPref('chat-nocolor');
    },
    formatCodeSpan: function () {
        return this.checkPref('chat-nocodespan');
    },
    formatCodeBlock: function () {
        return this.checkPref('chat-nocodeblock');
    },
    formatQuote: function () {
        return this.checkPref('chat-noquote');
    },
    showRealnames: function () {
        return this.multiline() && this.checkPref('chat-norealname');
    },
    isTimeRight: function () {
        return this.checkPref('time-left') || (this.avatarsEnabled() && this.multiline());
    },
    avatarsEnabled: function () {
        return this.checkPref('avatars-off');
    },
    imageAvatarsEnabled: function () {
        return this.avatarsEnabled() &&
            this.checkPref('avatars-image-off');
    },
    shouldPromptAvatar: function () {
        if (!this.imageAvatarsEnabled()) {
            return false;
        }
        if (this.getUser().getAvatar({
            buffer: this,
            forceExternal: true
        })) {
            return false;
        }
        return this.connection.nativeAvatarUploadsSupported() &&
            this.connection.checkPref('avatars-disableUploadPrompt');
    },
    isShowingDeletedMessages: function () {
        return this.checkPref('chat-deleted-show');
    }
}), {
    unrendered_pm_messages: [
        // No longer sent for PMs
        'connecting_failed',
        'connecting_cancelled',
        'socket_closed',
        'banned',
        'quit_server',
        'kill'
    ],
    unrendered_messages: [
        // Unused connection status
        'connected',
        'connecting_retry',
        'connecting_finished',
        'waiting_to_retry',
        'connecting',
        'joining',
        'doing_nickserv_login',
        'server_isupport',
        'server_myinfo',
        // Unused Backend status unused
        'connected',
        // Unused WHO
        'who_reply_channel',
        'who_end_user',
        'who_end_channel',
        'who_reply',
        'who_reply_user',
        'who_end',
        // Unnused WHOIS
        'whois_server',
        'whois_user',
        'whois_end',
        'whois_channels',
        'whois_idle',
        'whois_ip',
        'whois_info',
        'whois_operator',
        // Channel status
        'user_away',
        'user_back',
        'user_details',
        // Conversation status
        'whois_response',
        'away',
        // Connection status
        'isupport_params',
        'self_away',
        'self_back',
        // Overlay
        'names_reply',
        'query_too_long',
        'input_too_long',
        'try_again',
        'accept_list',
        'ban_list',
        'q_list',
        'a_list',
        'reop_list',
        'ignore_list',
        'ban_exception_list',
        'links_response',
        'silence_list',
        'trace_response',
        'who_response',
        'ison',
        'list_response_toomany',
        'list_response',
        'list_response_fetching',
        'map_list',
        'remote_isupport_params',
        'userhost',
        // Prompt
        'channel_full',
        'too_many_targets',
        'no_messages_from_non_registered',
        'not_registered',
        'already_registered',
        'chan_privs_needed',
        'users_dont_match',
        'need_more_params',
        'unknown_mode',
        'no_such_nick',
        'bad_channel_name',
        'bad_channel_key',
        'banned_from_channel',
        'oper_only',
        'invite_only_chan',
        'need_registered_nick',
        'no_such_channel',
        'too_many_channels',
        'users_disabled',
        'unknown_command',
        'no_such_server',
        'invalid_operator_password',
        'flood_warning',
        'privs_needed',
        'operator_fail',
        'not_on_channel',
        'ban_on_chan',
        'cannot_send_to_chan',
        'user_on_channel',
        'pong',
        'no_nick_given',
        'no_text_to_send',
        'no_origin',
        'only_servers_can_change_mode',
        'not_for_halfops',
        'silence',
        'channel_topic_is',
        'no_channel_topic',
        'channel_timestamp'
    ]
});


module.exports = Buf;



//////////////////
// WEBPACK FOOTER
// ./app/src/model/buf.js
// module id = t9zO
// module chunks = 1